/* eslint-disable */
// helpers
// import { dateTimeForTable } from "@/services/time.serivce";
// import { cents, money } from "@/utils/filters";
import _get from "lodash/get";
import _isNumber from "lodash/isNumber";

/**
 * Use this model for customers data
 *
 * @class
 */
export default class BookingModel implements IBookingModel {
  private _rawData: any;

  constructor(data: any) {
    this._rawData = data;
  }

  /**
   * Get authorization expiry
   *
   * @returns {string}
   */
  public get authorizationExpiry(): string {
    return this._rawData.getRaw("authorization_expiry") || "";
  }

  /**
   * Get authorization expiry string
   *
   * @returns {string}
   */
  public get authorizationExpiryString(): string {
    // return dateTimeForTable(this.authorizationExpiry);
    // TODO @Hamza Format it before populating it
    return this.authorizationExpiry;
  }

  /**
   * Get booking id number
   *
   * @returns {number}
   */
  public get bookingId(): number {
    return this._rawData.getRaw("booking_id");
  }

  /**
   * Get balance value
   *
   * @returns {number}
   */
  public get balanceValue(): number {
    const balanceValue = _get(this, "_rawData.data['balance_value'].raw", 0);

    return _isNumber(balanceValue) ? balanceValue : 0;
  }

  /**
   * Get balance value converted to money
   *
   * @returns {string}
   */
  public get balanceValueString(): string {
    // return cents(money(this.balanceValue));
    // TODO @Hamza Format it before populating it
    return this.balanceValue.toString();
  }

  /**
   * Get booking state
   *
   * @returns {number}
   */
  public get bookingState(): number {
    return Number(this._rawData.getRaw("booking_state"));
  }

  /**
   * Get booking payment status
   *
   * @returns {string}
   */
  public get bookingPaymentStatus(): string {
    return String(this._rawData.getRaw("booking_payment_status"));
  }

  /**
   * Get booking source
   *
   * @returns {string}
   */
  public get bookingSource(): string {
    return String(this._rawData.getRaw("booking_referer"));
  }

  /**
   * Get booking channel
   *
   * @returns {string}
   */
  public get bookingChannel(): string {
    return String(this._rawData.getRaw("booking_channel"));
  }

  /**
   * Get booking state name
   *
   * @returns {string}
   */
  public get bookingStateName(): string {
    return this._rawData.getRaw("booking_state_name") || "";
  }

  /**
   * Get created at
   *
   * @returns {string}
   */
  public get createdAt(): string {
    return this._rawData.getRaw("created_at") || "";
  }

  /**
   * Get created at string
   *
   * @returns {string}
   */
  public get createdAtString(): string {
    // return dateTimeForTable(this.createdAt);
    // TODO @Hamza Format it before populating it
    return this.createdAt;
  }

  /**
   * Get currency
   *
   * @returns {string}
   */
  public get currency(): string {
    return this._rawData.getRaw("currency");
  }

  /**
   * Get custom fields
   *
   * @returns {object}
   */
  public get customFields(): any {
    return this._rawData.getRaw("custom_fields");
  }

  /**
   * Get customer email
   *
   * @returns {string}
   */
  public get customerEmail(): string {
    return this._rawData.getRaw("customer_email");
  }

  /**
   * Get customer first name
   *
   * @returns {string}
   */
  public get customerFirstName(): string {
    return this._rawData.getRaw("customer_first_name");
  }

  /**
   * Get customer full name
   *
   * @returns {string}
   */
  public get customerFullName(): string {
    return this._rawData.getRaw("customer_full_name");
  }

  /**
   * Get customer id
   *
   * @returns {number}
   */
  public get customerId(): number {
    return Number(this._rawData.getRaw("customer_id"));
  }

  /**
   * Get customer last name
   *
   * @returns {string}
   */
  public get customerLastName(): string {
    return this._rawData.getRaw("customer_last_name");
  }

  /**
   * Get customer marketing
   *
   * @returns {number}
   */
  public get customerMarketing(): number {
    return Number(this._rawData.getRaw("customer_marketing"));
  }

  /**
   * Get customer marketing string
   *
   * @returns {string}
   */
  public get customerMarketingString(): string {
    return ""; //getSubscribeName(this.customerMarketing);
  }

  /**
   * Get deposit value
   *
   * @returns {number}
   */
  public get depositValue(): number {
    const balanceValue = _get(this, "_rawData.data['deposit_value'].raw", 0);

    return _isNumber(balanceValue) ? balanceValue : 0;
  }

  /**
   * Get balance value converted to money
   *
   * @returns {string}
   */
  public get depositValueString(): string {
    // return cents(money(this.depositValue));
    // TODO @Hamza Format it before populating it
    return this.depositValue.toString();
  }

  /**
   * Get group access
   *
   * @returns {string}
   */
  public get groupAccess(): string {
    return this._rawData.getRaw("group_access");
  }

  /**
   * Get id
   *
   * @returns {string}
   */
  public get id(): string {
    return this._rawData.getRaw("id");
  }

  /**
   * Get seller first name
   *
   * @returns {string}
   */
  public get sellerFirstName(): string {
    return this._rawData.getRaw("seller_first_name");
  }

  /**
   * Get seller full name
   *
   * @returns {string}
   */
  public get sellerFullName(): string {
    return this._rawData.getRaw("seller_full_name");
  }

  /**
   * Get seller id
   *
   * @returns {string}
   */
  public get sellerId(): string {
    return this._rawData.getRaw("seller_id");
  }

  /**
   * Get seller last name
   *
   * @returns {string}
   */
  public get sellerLastName(): string {
    return this._rawData.getRaw("seller_last_name");
  }

  /**
   * Get seller organisation id
   *
   * @returns {string}
   */
  public get sellerOrganisationId(): string {
    return this._rawData.getRaw("seller_organisation_id");
  }

  /**
   * Get seller organisation name
   *
   * @returns {string}
   */
  public get sellerOrganisationName(): string {
    return this._rawData.getRaw("seller_organisation_name");
  }

  /**
   * Get reference
   *
   * @returns {string}
   */
  public get reference(): string {
    return this._rawData.getRaw("reference");
  }

  /**
   * Get total value
   *
   * @returns {number}
   */
  public get totalValue(): number {
    return Number(this._rawData.getRaw("total_value"));
  }

  /**
   * Get total value converted to money
   *
   * @returns {string}
   */
  public get totalValueString(): string {
    // return cents(money(this.totalValue));
    // TODO @Hamza Format it before populating it
    return this.totalValue.toString();
  }

  /**
   * Get updated at
   *
   * @returns {string}
   */
  public get updatedAt(): string {
    return this._rawData.getRaw("updated_at") || "";
  }

  /**
   * Get updated at string
   *
   * @returns {string}
   */
  public get updatedAtString(): string {
    // return dateTimeForTable(this.updatedAt);
    // TODO @Hamza Format it before populating it
    return this.updatedAt;
  }

  /**
   * Get booking products
   *
   * @returns {string[]}
   */
  public get bookingProducts(): string[] {
    const products =
      this._rawData.getRaw("booking_products") || [];

    return products;
  }

  /**
   * Get booking tickets
   *
   * @returns {string[]}
   */
  public get bookingTickets(): string[] {
    const tickets =
      this._rawData.getRaw("booking_tickets") || [];

    return tickets;
  }

  /**
   * Get booking tickets
   *
   * @returns {string[]}
   */
  public get bookingsTicketQuantity(): any {
    const tickets =
      this._rawData.getRaw("bookings_ticket_quantity") || [];

    return tickets;
  }

  /**
   * Get booking referer
   *
   * @returns {string}
   */
  public get bookingReferer(): string {
    return this._rawData.getRaw("booking_referer") || "";
  }

  /**
   * Get booking Teams
   *
   * @returns {string[]}
   */
  public get bookingTeam(): string[] {
    return this._rawData.getRaw("booking_team") || [];
  }

  /**
   * Get bookingTeamSetting
   *
   * @returns {string[]}
   */
  public get bookingTeamSetting(): string[]{
    return this._rawData.getRaw("booking_team_setting") || [];
  }

  /**
   * Get bookingStartDatesQuantity
   *
   * @returns {number}
   */
  public get bookingStartDatesQuantity(): number{
    return Number(this._rawData.getRaw("booking_start_dates_quantity"));
  }

  /**
   * Get bookingStartDates
   *
   * @returns {string[]}
   */
  public get bookingStartDates(): string[] {
    return this._rawData.getRaw("booking_start_dates") || [];
  }

  /**
   * Get bookingTicketsName
   *
   * @returns {string[]}
   */
  public get bookingTicketsName(): string[] {
    return this._rawData.getRaw("booking_tickets_name") || [];
  }

  /**
   * Get bookingFirstStartDate
   *
   * @returns {string}
   */
  public get bookingFirstStartDate(): string {
    return this._rawData.getRaw("booking_first_start_date");
  }

}

interface IBookingModel {
  authorizationExpiry: string;
  authorizationExpiryString: string;
  bookingId: number;
  balanceValue: number;
  balanceValueString: string;
  bookingPaymentStatus: string;
  bookingState: number;
  bookingStateName: string;
  createdAt: string;
  createdAtString: string;
  currency: string;
  customFields: any;
  customerEmail: string;
  customerFirstName: string;
  customerFullName: string;
  customerId: number;
  customerLastName: string;
  customerMarketing: number;
  customerMarketingString: string;
  depositValue: number;
  depositValueString: string;
  groupAccess: string;
  id: string;
  sellerFirstName: string;
  sellerFullName: string;
  sellerId: string;
  sellerLastName: string;
  sellerOrganisationId: string;
  sellerOrganisationName: string;
  reference: string;
  totalValue: number;
  totalValueString: string;
  updatedAt: string;
  updatedAtString: string;
  bookingProducts: string[];
  bookingTickets: string[];
  bookingReferer: string;
  bookingTeam: string[];
  bookingTeamSetting: string[],
  bookingStartDatesQuantity: number,
  bookingStartDates: string[],
  bookingFirstStartDate: string,
}

export const MAP_ATTRIBUTES: any = {
  authorizationExpiry: "authorization_expiry",
  authorizationExpiryString: "authorization_expiry",
  bookingId: "booking_id",
  balanceValue: "balance_value",
  balanceValueString: "balance_value",
  bookingPaymentStatus: "booking_payment_status",
  bookingState: "booking_state",
  bookingStateName: "booking_state_name",
  createdAt: "created_at",
  createdAtString: "created_at",
  currency: "currency",
  customFields: "custom_fields",
  customerEmail: "customer_email",
  customerFirstName: "customer_first_name",
  customerFullName: "customer_full_name",
  customerId: "customer_id",
  customerLastName: "customer_last_name",
  customerMarketing: "customer_marketing",
  customerMarketingString: "customer_marketing",
  depositValue: "deposit_value",
  depositValueString: "deposit_value",
  groupAccess: "group_access",
  id: "id",
  sellerFirstName: "seller_first_name",
  sellerFullName: "seller_full_name",
  sellerId: "seller_id",
  sellerLastName: "seller_last_name",
  sellerOrganisationId: "seller_organisation_id",
  sellerOrganisationName: "seller_organisation_name",
  reference: "reference",
  totalValue: "total_value",
  totalValueString: "total_value",
  updatedAt: "updated_at",
  updatedAtString: "updated_at",
  bookingProducts: "booking_products",
  bookingTickets: "booking_tickets",
  bookingTicktsQuantity: "bookings_ticket_quantity",

  bookingReferer: "booking_referer",
  bookingChannel: "booking_channel",
  bookingTeam: "booking_team",
  bookingTeamSetting: "booking_team_setting",
  bookingFirstStartDate: "booking_first_start_date",
};
